import React from "react";

const ModalHeader = ({ children }) => {
    return <div className="Modal-subhead">{children}</div>;
};

export default ModalHeader;
